import { render, staticRenderFns } from "./BaseImage.vue?vue&type=template&id=3a1b68fd&"
import script from "./BaseImage.vue?vue&type=script&lang=js&"
export * from "./BaseImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a1b68fd')) {
      api.createRecord('3a1b68fd', component.options)
    } else {
      api.reload('3a1b68fd', component.options)
    }
    module.hot.accept("./BaseImage.vue?vue&type=template&id=3a1b68fd&", function () {
      api.rerender('3a1b68fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseImage.vue"
export default component.exports